export const defaultDateFormatOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
